import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_add_more_plans_to_program~1
			funnel: {
				id: 'ob-female-funnel-add-more-plans',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_add_more_plans_to_program~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_add_more_plans_to_program/fasting/__b'
					),
			},
		},
		'activity-female-walking': {
			// ?safe&utm_source=FB&country=US&area=activity-female-walking&exp=web_add_more_plans_to_program~1
			funnel: {
				id: 'ob-female-activity-walking-add-more-plans',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_add_more_plans_to_program~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_add_more_plans_to_program/walking-f/__b'
					),
			},
		},
	},
]

export default config
